import requester from '@/lib/axios';
import { MULTIPART_FORM_DATA_HEADERS as headers } from '@/constants';
import JsonApiResponse from '@/models/JsonApiResponse';
import { BaseFilters } from '@/models/Service';
import { CourseModule } from '@/models/CourseModule';
import {
  convertToFormData,
  bannerImgConverter,
} from '@/utils/convertToFormData';

export type ListCourseModuleFilters = BaseFilters & {
  courseLineId?: number;
};

export const listCourseModules = async (
  courseLineId: number,
  filters: ListCourseModuleFilters = {},
) => {
  const { data } = await requester().get<JsonApiResponse<CourseModule>>(
    `course-lines/${courseLineId}/modules/`,
    { params: filters },
  );
  return data;
};

export const getCourseModule = async (courseLineId: number, id: number) => {
  const { data } = await requester().get<CourseModule>(
    `course-lines/${courseLineId}/modules/${id}/`,
  );
  return data;
};

export type CreateCourseModule = Omit<
  CourseModule,
  'id' | 'createdAt' | 'updatedAt' | 'courseLineId' | 'order'
> & { order?: number };

export const createCourseModule = async (
  courseLineId: number,
  body: CreateCourseModule,
) => {
  const formData = convertToFormData(body, {
    bannerImg: bannerImgConverter,
  });

  const { data } = await requester().post<CourseModule>(
    `course-lines/${courseLineId}/modules/`,
    formData,
    { headers },
  );

  return data;
};

export type UpdateCourseModule = Partial<CreateCourseModule>;

export const updateCourseModule = async (
  courseLineId: number,
  id: number,
  body: UpdateCourseModule,
) => {
  const formData = convertToFormData(body, {
    bannerImg: bannerImgConverter,
  });

  const { data } = await requester().patch<CourseModule>(
    `course-lines/${courseLineId}/modules/${id}/`,
    formData,
    { headers },
  );

  return data;
};

export const deleteCourseModule = async (courseLineId: number, id: number) => {
  await requester().delete(`course-lines/${courseLineId}/modules/${id}/`);
};

export type ReorderCourseModulesPayload = { id: number }[];

export const reorderCourseModules = async (
  courseLineId: number,
  payload: ReorderCourseModulesPayload,
) => {
  await requester().patch<void>(
    `course-lines/${courseLineId}/modules/order/`,
    payload,
  );
};
